<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  updated() {
    if (this.$route.meta.name) {
      document.title = this.$route.meta.name
    }
  }
};
</script>
